import { createStore } from '@ngneat/elf';
import { withEntities } from '@ngneat/elf-entities';
import { Notification } from '@thiememeulenhoff/types';

export const notifications = createStore(
  { name: 'notifications' },
  withEntities<Notification, 'id'>({
    idKey: 'id',
  }),
);
